module.exports = __webpack_public_path__ + "static/media/CTLI_9-178w.9496dd60.jpg";